// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compare-section__introduction{background-color:#fff;border-bottom:2px solid var(--theme-neutral-background)}.compare-section__heading{color:var(--theme-primary-color)}.compare-section__theses+.compare-section__theses{border-top:2px solid var(--theme-neutral-background)}", ""]);
// Exports
module.exports = exports;
